import NotEditableModal from './NotEditableModal';

export default NotEditableModal;